import { omit } from 'lodash-es';
import { METRICS_INTERVAL_DEFAULT_S } from '@/constants';
import type {
  BackendController,
  Controller,
  Coordinates,
  UpdatedController,
} from '@/types';

export const toCoordinates = (
  latitude: BackendController['latitude'],
  longitude: BackendController['longitude'],
): Coordinates | null =>
  latitude && longitude
    ? ([Number(latitude), Number(longitude)] as Coordinates)
    : null;

// `group` is skipped: the response carries an id, the controller an object.
export const mergeControllerUpdate = (
  controller: Controller,
  update: UpdatedController,
): Controller => ({
  ...controller,
  ...omit(update, ['latitude', 'longitude', 'group']),
  coordinates: toCoordinates(update.latitude, update.longitude),
});

export const patchController = (value: BackendController): Controller => {
  return {
    ...omit(value, ['latitude', 'longitude']),
    coordinates: toCoordinates(value.latitude, value.longitude),
    showMetricsUpdateBanner: value.showMetricsUpdateBanner ?? false,
    metricsSendIntervalSeconds:
      value.metricsSendIntervalSeconds ?? METRICS_INTERVAL_DEFAULT_S,
  };
};
